import { useServices } from "@/services-context.tsx";
import { CATEGORIES_LISTENER_NAME } from "@/services/categories.ts";
import { CUSTOMER_CHANNEL_LISTENER_NAME } from "@/services/customer-channel.ts";

export function useHomeCommon() {
  const { categories, customerChannel } = useServices([CATEGORIES_LISTENER_NAME, CUSTOMER_CHANNEL_LISTENER_NAME]);
  const isLoggedIn = !!customerChannel.customer;
  const topLevelCategories = categories.findTopLevelCategories().map(({ id }) => {
    const { level, image, ...rest } = categories.getItem(id);
    return {
      ...rest,
      image: image ?? null,
      level: level != null ? String(level) : null,
    };
  });

  return {
    isLoggedIn,
    topLevelCategories,
  };
}
